import { render, staticRenderFns } from "./descriptive_balance_detailsprint.vue?vue&type=template&id=15c05939&scoped=true&"
import script from "./descriptive_balance_detailsprint.vue?vue&type=script&lang=js&"
export * from "./descriptive_balance_detailsprint.vue?vue&type=script&lang=js&"
import style0 from "./descriptive_balance_detailsprint.vue?vue&type=style&index=0&id=15c05939&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c05939",
  null
  
)

export default component.exports